import "../../index51.css";
import { jsx as c } from "react/jsx-runtime";
import p from "react";
import { a as l } from "../../type-BFTbooL7.js";
import { _ as f } from "../../cs-piwRuCFZ.js";
const _ = "_raw-input_gcati_1", d = {
  rawInput: _
};
function I(r) {
  const {
    className: o,
    onChange: t,
    elementRef: s,
    value: i,
    name: a,
    ...u
  } = r, m = p.useCallback((e) => {
    const n = e.currentTarget.value;
    t && t(
      n === "" ? void 0 : n,
      a,
      e
    );
  }, [a, t]);
  return /* @__PURE__ */ c(
    "input",
    {
      ...u,
      ref: s,
      className: f(
        d.rawInput,
        o
      ),
      name: l(a) ? String(a) : void 0,
      onChange: m,
      value: i ?? ""
    }
  );
}
export {
  I as default
};
